import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/icons/workflow/close.svg'
import _imports_1 from '../../../public/icons/dialog/info_whatsnew.svg'
import _imports_2 from '../../../public/icons/dialog/ellipse.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2e8933b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { style: {"padding-top":"10px","padding-right":"12px","padding-bottom":"6px","padding-left":"12px","width":"100%","height":"41px"} }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  class: "center",
  style: {"height":"7%","font-weight":"bold","text-align":"center","font-size":"22px","padding-bottom":"10px"}
}
const _hoisted_7 = {
  key: 0,
  class: "center",
  style: {"margin-top":"40px"}
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  id: "learnmore",
  class: "learnmore"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imghelper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "learnmoreimg",
    class: "accent-svg",
    style: {"width":"24px","height":"24px"},
    src: _imports_1
  })
], -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 3,
  class: "learnmore"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"24px"} }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "ellipse" }
const _hoisted_16 = ["id"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["id"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_portal = _resolveComponent("portal")!

  return (_openBlock(), _createBlock(_component_portal, { to: "DialogsContainer" }, {
    default: _withCtx(() => [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(['modal-container', _ctx.containerStyle]),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.MainClick && _ctx.MainClick(...args)))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      id: "close",
                      src: _imports_0,
                      class: "theme-svg",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Localizer.Localize("WhatsNewHeader")), 1),
                  (!_ctx.IsHtml)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.message), 1))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "whatsnewhtml html",
                        innerHTML: _ctx.$sanitize(_ctx.message)
                      }, null, 8, _hoisted_8)),
                  (_ctx.showLearnMore)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("a", {
                          id: "learnmoretext",
                          href: _ctx.thisArticle.moreDetailsLink,
                          target: "_blank"
                        }, "Learn More", 8, _hoisted_11)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfMessages, (html, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (index==0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              id: `img-${index}`,
                              class: "accent-svg"
                            }, _hoisted_18, 8, _hoisted_16))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              id: `img-${index}`
                            }, _hoisted_21, 8, _hoisted_19))
                      ], 64))
                    }), 256))
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createVNode(_component_CommonButton, {
                      type: _ctx.ButtonType.Primary,
                      text: _ctx.Localizer.Localize('Back'),
                      onClick: _ctx.PrevPageClick
                    }, null, 8, ["type", "text", "onClick"]),
                    _createVNode(_component_CommonButton, {
                      type: _ctx.ButtonType.Default,
                      text: _ctx.Localizer.Localize('Close'),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                    }, null, 8, ["type", "text"]),
                    _createVNode(_component_CommonButton, {
                      type: _ctx.ButtonType.Primary,
                      text: _ctx.Localizer.Localize('Next'),
                      onClick: _ctx.NextPageClick
                    }, null, 8, ["type", "text", "onClick"])
                  ], true)
                ])
              ], 2)
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}